import React from "react";
import { useStudentForm } from "./hooks/use-student-form";
import { Select } from "components/form-component/select/select";
import { Input } from "components/form-component/input/input";
import {
  Dashed,
  FormStyles,
  DataHeading,
  DataStyles,
  WrapperWidth,
  FlexGrowWrapper,
  SpaceWrapper,
  ButtonCTA,
  FormWrapper
} from "./user-profile-form.styles";
import { userTypes, nameTitles } from "constants/constants";
import { IUserProfileFormWithMixpanel } from "./use-profile-form.types";
import { VerifiedInput } from "components/form-component/verified-input/verified-input";
import { monetisationClassOptions } from "constants/constants";
import { MobileInput } from "components/form-component/mobile-input/mobile-input";
import { Alert } from "components/atoms/alert/alert";

const StudentForm = ({
  userType,
  defaultGrade,
  summaryPackageData
}: IUserProfileFormWithMixpanel): JSX.Element => {
  const {
    control,
    handleSubmit,
    isValid,
    onSubmit,
    getPhoneNumberFromRegisterToken,
    isLoading
  } = useStudentForm(userType, summaryPackageData, defaultGrade);
  return (
    <FormWrapper onSubmit={handleSubmit(onSubmit)}>
      <VerifiedInput
        label="Nomor HP"
        defaultValue={getPhoneNumberFromRegisterToken}
        name="verifiedInput"
      />

      <Alert
        variant="info"
        alertText="Paket belajar akan diaktifkan di nomor ini."
      />

      <FormStyles>
        <WrapperWidth width="20%">
          <Select
            name="userType"
            control={control}
            label="Saya Adalah"
            options={userTypes}
            testId="user-type-dropdown"
          />
        </WrapperWidth>

        <FlexGrowWrapper>
          <Input
            name="name"
            data-testid="name-field"
            label="Nama"
            control={control}
            placeholder="Isi namamu di sini. Pakai nama asli, ya!"
          />
        </FlexGrowWrapper>

        <WrapperWidth width="20%">
          <Select
            name="grade"
            testId="grade-dropdown"
            control={control}
            label="Kelas"
            options={monetisationClassOptions}
            placeholder="Pilih kelas"
          />
        </WrapperWidth>
      </FormStyles>
      <Input
        name="email"
        label="Email"
        data-testid="email-field"
        control={control}
        placeholder="Isi alamat emailmu di sini"
      />

      <Dashed />

      <DataHeading>Data Orangtua</DataHeading>
      <FormStyles>
        <DataStyles>
          <WrapperWidth width="30%">
            <Select
              testId="salutation-dropdown"
              name="salutation"
              control={control}
              label="Nama Orangtua"
              options={nameTitles}
            />
          </WrapperWidth>

          <FlexGrowWrapper>
            <Input
              data-testid="parent-name-field"
              control={control}
              name="parentName"
              placeholder="isi nama orangtuamu di sini"
            />
          </FlexGrowWrapper>
        </DataStyles>

        <DataStyles>
          <MobileInput
            control={control}
            placeholder="Isi nomor HP orangtuamu di sini"
            label="Nomor HP Orangtua"
            name="parentNumber"
          />
        </DataStyles>
      </FormStyles>

      <SpaceWrapper>
        <ButtonCTA
          disabled={!isValid}
          type="submit"
          variant="primary"
          isLoading={isLoading}
          data-testid="register-profile-button"
          loadingText={"Membuat profil"}>
          Buat profil
        </ButtonCTA>
      </SpaceWrapper>
    </FormWrapper>
  );
};

export { StudentForm };
